
import React, { Fragment, useState } from 'react'
import { Button, Col, FormGroup, FormLabel, Modal, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'
import { updateConstraintsAction } from '@/Redux/Actions/ProgrammationManagerActions'
import { addConstraint } from '@/Services/ProgrammationManagerService'

import InputText from '../../components/InputText'
import InputSelect from '../../components/InputSelect'

import AddICon from '../../../SvgImages/Add'

import './ConstraintCreator.scss'
import Textarea from '../../components/Textarea'

interface Props {
  subTask?: any
}

const ConstraintCreator = ({ subTask }: Props) => {

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const { itemOpened, setEditingItem, patchItemOpened } = useProgrammation()

  const { users } = useSelector((state: any) => state.ProgrammationReducer)

  const [ showModal, setShowModal ] = useState(false)
  const [ name, setName ] = useState('')
  const [ description, setDescription ] = useState('')
  const [ family, setFamily ] = useState('general')
  const [ responsible, setResponsible ] = useState('')
  const [ creating, setCreating ] = useState(false)

  const task = subTask || itemOpened

  const familiesOptions = [
    { _id: 'general', name: t('CONSTRAINT_CREATOR:FamilyGeneral') },
    { _id: 'coordination', name: t('CONSTRAINT_CREATOR:FamilyCoordination') },
    { _id: 'resource', name: t('CONSTRAINT_CREATOR:FamilyResource') },
    { _id: 'time', name: t('CONSTRAINT_CREATOR:FamilyTime') },
    { _id: 'space', name: t('CONSTRAINT_CREATOR:FamilySpace') },
    { _id: 'design', name: t('CONSTRAINT_CREATOR:FamilyDesign') },
    { _id: 'logistic', name: t('CONSTRAINT_CREATOR:FamilyLogistic') },
  ]

  const handleAddConstraint = async () => {

    setEditingItem(true)
    setCreating(true)

    const [ error, data ] = await addConstraint(task._id, { name, description, family, responsible })

    setCreating(false)
    setEditingItem(false)

    if (error) {
      return console.log(error)
    }

    setName('')
    setDescription('')
    setFamily('')
    setResponsible('')

    if (!subTask) {
      patchItemOpened({
        restrictions: [...data.task.restrictions]
      })
    } else {
      const subTasks = itemOpened.subTasks

      subTasks.forEach((subTask: any) => {

        if (subTask._id === task._id) {

          subTask.restrictions = [...data.task.restrictions]
        }
      })

      patchItemOpened({
        subTasks
      })
    }

    dispatch(updateConstraintsAction({ task: data.task, parentTask: data.parentTask }))

    setShowModal(false)
  }

  return (
    <Fragment>
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className='mb-2'
      >
        <AddICon fill="#fff" height={24} width={24} />
      </Button>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        backdropClassName='constraint-creator-backdrop'
        className='constraint-creator'
      >
        <Modal.Header>
          <Modal.Title>
             {t('CONSTRAINT_CREATOR:Title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelName')}
            </FormLabel>
            <InputText
              placeholder="Name"
              value={name}
              onChange={setName}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelDescription')}
            </FormLabel>
            <Textarea
              value={description}
              onChange={setDescription}
              placeholder="Descripción"
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelFamily')}
            </FormLabel>
            <InputSelect
              value={family}
              options={familiesOptions}
              onChange={setFamily}
            />
          </FormGroup>
          <FormGroup className='mb-4'>
            <FormLabel>
              {t('CONSTRAINT_CREATOR:LabelAssignee')}
            </FormLabel>
            <InputSelect
              placeholder="Responsible"
              value={responsible}
              options={users.map((u: any) => ({ _id: u._id, name: `${u.name} (${u.surname})` }))}
              onChange={setResponsible}
            />
          </FormGroup>
          <Row>
            <Col style={{ textAlign: 'right' }}>
              <Button
                variant='primary'
                onClick={() => handleAddConstraint()}
                disabled={!name || !family || !responsible}
              >
                <AddICon fill="#fff" height={24} width={24} />{' '}
                {!creating && t('CONSTRAINT_CREATOR:AddButton')}
                {creating && t('CONSTRAINT_CREATOR:AddButtonAdding')}
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default ConstraintCreator
